module.exports = __webpack_public_path__ + "img/Barbados.742c6701.svg";